import { Box, List, ListItem, ListProps, styled, Typography } from "@mui/material";

export const StyledContentPageTitle = styled(Typography)`
  color: ${(props) => props.theme.palette.primary.main};
  font-weight: 600;
  font-size: ${(props) =>
    props.variant === "h5" ? "clamp(0.75rem, 1.75vw, 1rem)" : "clamp(1.25rem, 3vw, 1.5rem)"};
  margin-top: ${(props) =>
    props.variant === "h5" ? props.theme.spacing(2) : props.theme.spacing(4)};
`;

export const StyledContentParagraph = styled(Box)`
  text-align: justify;
  margin-top: ${(props) => props.theme.spacing(2)};
`;

interface StyledContentListProps extends ListProps {
  variant?: "circle" | "disc";
}

export const StyledContentList = styled(List)<StyledContentListProps>`
  list-style-type: ${(props) => props.variant || "disc"};
  padding-left: ${(props) => props.theme.spacing(2)};
  & .MuiListItem-root {
    display: list-item;
  }
`;

export const StyledContentListItem = styled(ListItem)`
  margin-top: ${(props) => props.theme.spacing(props.disablePadding ? 0 : 2)};
`;
